/** Iconos SVG minimalistas (stroke), color hereda `currentColor`. */

function svgShell(viewBox: string, paths: string): SVGSVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', viewBox);
  svg.setAttribute('fill', 'none');
  svg.setAttribute('stroke', 'currentColor');
  svg.setAttribute('stroke-width', '2');
  svg.setAttribute('stroke-linecap', 'round');
  svg.setAttribute('stroke-linejoin', 'round');
  svg.setAttribute('aria-hidden', 'true');
  svg.innerHTML = paths;
  return svg;
}

export function iconMap(): SVGSVGElement {
  return svgShell(
    '0 0 24 24',
    '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>'
  );
}

export function iconChat(): SVGSVGElement {
  return svgShell(
    '0 0 24 24',
    '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>'
  );
}

export function iconBuilding(): SVGSVGElement {
  return svgShell(
    '0 0 24 24',
    '<path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/><path d="M9 9v0"/><path d="M9 12v0"/><path d="M9 15v0"/><path d="M9 18v0"/>'
  );
}

export function iconAlert(): SVGSVGElement {
  return svgShell(
    '0 0 24 24',
    '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>'
  );
}

export function iconCheck(): SVGSVGElement {
  return svgShell('0 0 24 24', '<polyline points="20 6 9 17 4 12"/>');
}

export function iconClose(): SVGSVGElement {
  return svgShell('0 0 24 24', '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>');
}

/** Reasignación / intercambio de colaborador. */
export function iconSwap(): SVGSVGElement {
  return svgShell(
    '0 0 24 24',
    '<polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>'
  );
}
